export enum FileMimeType {
  Bmp = 'image/bmp',
  Csv = 'text/csv',
  Doc = 'application/msword',
  Docm = 'application/vnd.ms-word.document.macroenabled.12',
  Docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  Gif = 'image/gif',
  Heic = 'image/heic',
  Html = 'text/html',
  Jpeg = 'image/jpeg',
  Jpg = 'image/jpeg',
  Json = 'application/json',
  Md = 'text/markdown',
  Msg = 'application/vnd.ms-outlook',
  Tif = 'image/tif',
  Tiff = 'image/tiff',
  Pdf = 'application/pdf',
  Potx = 'application/vnd.openxmlformats-officedocument.presentationml.template',
  Pptm = 'application/vnd.ms-powerpoint.presentation.macroenabled.12',
  Png = 'image/png',
  Pptx = 'application/vnd.ms-powerpoint',
  Rtf = 'application/rtf',
  Sfdt = 'application/sfdt',
  Txt = 'text/plain',
  Webp = 'image/webp',
  Wpd = 'application/vnd.wordperfect',
  Xhtml = 'application/xhtml+xml',
  Xls = 'application/vnd.ms-excel',
  Xlsm = 'application/vnd.ms-excel.sheet.macroenabled.12',
  Xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  Xps = 'application/vnd.ms-xpsdocument',
  // TODO server should deprecate the unofficial mime type
  DocUnofficial = 'application/doc',
  DocxUnofficial = 'application/docx',
  JpegUnofficial = 'application/jpeg',
  JpgUnofficial = 'application/jpg',
  PngUnofficial = 'application/png',
  TifUnofficial = 'application/tif',
  TiffUnofficial = 'application/tiff',
}
